import React from "react";
import './features.css';

function Features() {
   return (
       <div className="content-box width-1000">
          <div className="title-font">A Lot of Features</div>
          <ul className="features flex flex-wrap align-stretch hr-space-between">
             <li className="small engagement">
                <div className="feature-title rubik-medium">Engagement Insights</div>
                <div className="feature-desc">
                   Enhanced analytics on views, watch<br/> time, CTA clickthroughs
                </div>
             </li>
             <li className="big interactive">
                <div className="feature-title rubik-medium">Interactive</div>
                <div className="feature-desc">
                   Your viewers can annotate and<br/> leave a comment anywhere on the<br/> video
                </div>
             </li>
             <li className="big insert">
                <div className="feature-title rubik-medium">Insert Calls-To-Action</div>
                <div className="feature-desc">
                   Guide your users to take further action<br/> via customizable calls-to-action<br/> buttons
                </div>
             </li>
             <li className="small embed">
                <div className="feature-title rubik-medium">Embed anywhere</div>
                <div className="feature-desc">
                   Embed interactive demos and<br/> videos anywhere on your website,<br/> social media or email.
                </div>
             </li>
             <li className="small no-code">
                <div className="feature-title rubik-medium">No-code builder</div>
                <div className="feature-desc">
                   Create interactive videos and demos<br/> in seconds. Tailor to your needs and<br/> goals like a pro.
                </div>
             </li>
             <li className="big branding">
                <div className="feature-title rubik-medium">Custom branding</div>
                <div className="feature-desc">
                   Add your company’s logo and brand<br/> colors to the videos and collateral<br/> you create.
                </div>
             </li>
          </ul>
       </div>
   )
}

export default Features;
